import React from "react";
import styles from "./style.module.css";
// import ServiceOfferings from "../ServiceOfferings";

import altBankBlackGoldLogo from '../../assets/images/white-logo.svg';
// import LocatorServices from "../ServiceOfferings/LocatorServices";

import CbnFooter from "../../Components/CbnFooter";
import NinPortal from "../../Components/NInPortal";



export default function Sliders() {
  return (
    <div className={styles.body}>
      <ul className={styles.slideshow}>
        <li>
          <span>Image 01</span>
        </li>
        <li>
          <span>Image 02</span>
        </li>
        <li>
          <span>Image 03</span>
        </li>
        <li>
          <span>Image 04</span>
        </li>
        <li>
          <span>Image 05</span>
        </li>
        <li>
          <span>Image 06</span>
        </li>
      </ul>
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <img src={altBankBlackGoldLogo} alt="" className={styles.logo} />
        </div>
        <div className={styles.flexContainer}>
          <div className={styles.textHolder}>
           
            {/* eslint-disable */}
            <h1></h1>
          </div>
          <div>
          <NinPortal />
            <div className={styles.locatorServices}>
              {/* <LocatorServices /> */}
              <div className={styles.footerContainer}>
                <CbnFooter />
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
